export default "__VITE_ASSET__Ua$quSOM__"